import { Descriptions } from "antd";

export function ProjectInfo({ project }: any) {
  return (
    <Descriptions column={{ xs: 1, sm: 1, md: 2 }} size="small">
      <Descriptions.Item label="Project">{project.name}</Descriptions.Item>
      <Descriptions.Item label="ID">{project.id}</Descriptions.Item>
      <Descriptions.Item label="Project  Identifier">{project.identifier}</Descriptions.Item>
      <Descriptions.Item label="Project Secret">{project.secret}</Descriptions.Item>
    </Descriptions>
  );
}
